import React from "react";
import { observer } from "mobx-react";
import { FormSpy } from "react-final-form";

import { Button, Typography } from "@material-ui/core";

import FormControl, { UploadPreviewFieldControl } from "components/FormControl";
import SubmitButtonControl from "components/FormControl/SubmitButtonControl";
import LoadingButton from "components/LoadingButton";
import Row from "components/Form/Row";

import {
  compose,
  fileSizeValidator,
  imageIsCorruptedValidator,
  imageTypesValidator,
} from "utils/validators";

import {
  Container,
  TitleContainer,
  Buttons,
  ButtonContainer,
  SubtitleContainer,
} from "./styles";

type FormSubmitData = {
  values: any;
};

type Props = {
  dayTypeName: string;
  onClose: () => void;
  onChangeIsDirty: (params: { dirty: boolean }) => void;
  onSubmit: (data: FormSubmitData) => void;
  dayTypeId?: number;
  file?: string;
  imageId?: number;
  isLoading?: boolean;
};

const ACCEPTED_IMAGE_TYPE = ".png";
const MAX_FILE_SIZE_IN_MB = 10;

@observer
class ImageForm extends React.Component<Props> {
  get isEditMode() {
    const { file } = this.props;
    return !!file;
  }

  get formTitle() {
    return !this.isEditMode ? "Add Image" : "Edit Image";
  }

  get initialValues() {
    const { dayTypeId, file, imageId } = this.props;

    return { dayTypeId, file, id: imageId };
  }

  formFileValidator = (acceptedTypes: string) => (value?: File) =>
    imageTypesValidator(value?.type ?? "", acceptedTypes);

  render() {
    const { dayTypeName, onClose, onSubmit, onChangeIsDirty } = this.props;

    return (
      <FormControl onSubmit={onSubmit} initialValues={this.initialValues}>
        <FormSpy subscription={{ dirty: true }} onChange={onChangeIsDirty} />
        <Container>
          <Row>
            <TitleContainer>
              <Typography variant="h1" color="textPrimary">
                {this.formTitle}
              </Typography>
              <SubtitleContainer>
                <Typography>{dayTypeName}</Typography>
              </SubtitleContainer>
            </TitleContainer>
          </Row>

          <Row>
            <UploadPreviewFieldControl
              name="file"
              title="Image"
              acceptedFiles={ACCEPTED_IMAGE_TYPE}
              validate={compose(
                this.formFileValidator(ACCEPTED_IMAGE_TYPE),
                fileSizeValidator(MAX_FILE_SIZE_IN_MB),
                imageIsCorruptedValidator,
              )}
              withoutDeleteAction
              required
            />
          </Row>
        </Container>

        <Buttons>
          <ButtonContainer>
            <Button
              variant="outlined"
              color="primary"
              onClick={onClose}
              fullWidth
            >
              Cancel
            </Button>
          </ButtonContainer>
          <ButtonContainer>
            <SubmitButtonControl render={this.renderButton} />
          </ButtonContainer>
        </Buttons>
      </FormControl>
    );
  }

  renderButton = ({ onClick }: { onClick: () => void }) => (
    <LoadingButton
      onClick={onClick}
      variant="contained"
      color="primary"
      isLoading={this.props.isLoading}
      fullWidth
    >
      {!this.isEditMode ? "Add" : "Save"}
    </LoadingButton>
  );
}

export default ImageForm;
